var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavHebergement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "needfill",
    d: "M3.1,12.9c-0.8,0-1.4,0.6-1.4,1.4v3.2c0,0.1,0.1,0.2,0.2,0.2h19.9c0.1,0,0.2-0.1,0.2-0.2v-3.2 c0-0.8-0.6-1.4-1.4-1.4H3.1z M21.9,19.4H2c-1,0-1.9-0.9-1.9-1.9v-3.2c0-1.7,1.4-3.1,3.1-3.1h17.7c1.7,0,3.1,1.4,3.1,3.1v3.2 C23.9,18.6,23.1,19.4,21.9,19.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "needfill",
    d: "M20.9,12.9c-0.5,0-0.8-0.3-0.8-0.8V6.4c0-1.4-1.1-2.5-2.5-2.5H6.5C5.1,4,4,5,4,6.4V12 c0,0.5-0.3,0.8-0.8,0.8c-0.5,0-0.8-0.3-0.8-0.8V6.4c0-2.3,1.8-4.1,4.1-4.1h11.1c2.3,0,4.1,1.8,4.1,4.1V12 C21.7,12.6,21.4,12.9,20.9,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "needfill",
    d: "M21.9,21.7c-0.5,0-0.8-0.3-0.8-0.8v-2.2c0-0.5,0.3-0.8,0.8-0.8c0.5,0,0.8,0.3,0.8,0.8v2.2 C22.7,21.3,22.4,21.7,21.9,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "needfill",
    d: "M2,21.7c-0.5,0-0.8-0.3-0.8-0.8v-2.2c0-0.5,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v2.2C2.8,21.3,2.5,21.7,2,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "needfill",
    d: "M17,12.9c-0.5,0-0.8-0.3-0.8-0.8c0-1.4-1.1-2.5-2.5-2.5h-3.3c-1.4,0-2.5,1.1-2.5,2.5c0,0.5-0.3,0.8-0.8,0.8 c-0.5,0-0.8-0.3-0.8-0.8C6.3,9.8,8.1,8,10.4,8h3.3c2.3,0,4.1,1.8,4.1,4.1C17.8,12.6,17.5,12.9,17,12.9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHebergement);
export default __webpack_public_path__ + "static/media/nav_hebergement.eea01cb4c7acff319175bb014a7473ab.svg";
export { ForwardRef as ReactComponent };